import classNames from "classnames";
import Icon from "../Icon";

import styles from "./ButtonCategory.module.css";

type Props = {
  text: string;
  icon?: string;
  active?: boolean;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
};

export const ButtonCategory = ({
  text,
  icon = "normal",
  active = false,
  disabled = false,
  loading = false,
  onClick,
}: Props) => {
  const buttonClass = classNames(
    styles.button,
    loading ? styles["-loading"] : false,
    active ? styles["-active"] : false
  );

  // ButtonCategory
  return (
    <button onClick={onClick} className={buttonClass} disabled={disabled}>
      <div className={styles.icon}>
        <Icon type={icon} size="tiny" inverted={active} />
      </div>
      {text}
    </button>
  );
};
